import { marked } from 'marked';

let configured = false;

/**
 * Align marked with StreamingMarkdown / chat: GFM + line breaks as <br>.
 */
export function ensureMarkedConfigured() {
  if (configured) {
    return;
  }
  marked.setOptions({
    breaks: true,
    gfm: true,
  });
  configured = true;
}

/**
 * @param {string} markdown
 * @returns {string}
 */
export function parseMarkdownToHtml(markdown) {
  ensureMarkedConfigured();
  let src = (markdown || '').trim();
  if (!src) {
    return '';
  }
  // AI-generated markdown may contain literal \n escape sequences instead
  // of real newline characters (e.g. from JSON serialization round-trips).
  // Normalize them so marked can parse line/paragraph breaks correctly.
  src = src.replace(/\\n/g, '\n');
  const html = marked.parse(src);
  return normalizeHtmlForQuill(html);
}

/**
 * Quill's .ql-editor uses white-space:pre-wrap, which renders literal \n
 * characters between HTML tags as visible line breaks. marked.parse()
 * produces newlines between tags (e.g. </h1>\n<p>) that Quill's own
 * serializer would never emit. Collapse them so portal rendering matches
 * what Quill produces after a round-trip through its Delta format.
 *
 * @param {string} html
 * @returns {string}
 */
export function normalizeHtmlForQuill(html) {
  if (!html) {
    return '';
  }
  return html.replace(/>\s*\n\s*</g, '><').trim();
}
